import { render } from "./SalesMatchCard.vue?vue&type=template&id=2c919150&scoped=true"
import script from "./SalesMatchCard.vue?vue&type=script&lang=js"
export * from "./SalesMatchCard.vue?vue&type=script&lang=js"

import "./SalesMatchCard.vue?vue&type=style&index=0&id=2c919150&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c919150"]])

export default __exports__